<template>
  <v-container fluid>
    <h2 class="page-title mb-1">Customer Success</h2>
    <p class="page-desc mb-4">
      Activación y Uso por contrato. La activación se mide contra la cuota contratada
      en Employee Benefit —donde superar el 100% significa consumo por sobre lo vendido—
      y contra los usuarios cargados en el resto de las líneas. Uso: membresías que usan
      televet, reembolso o ficha médica sobre membresías activas.
    </p>

    <ContractSuccessTable />
  </v-container>
</template>

<script>
import ContractSuccessTable from '@/components/ContractSuccessTable.vue';

export default {
  name: 'ContractSuccess',
  components: { ContractSuccessTable },
};
</script>

<style scoped>
.page-title {
  color: #104b94;
  font-weight: 700;
}
.page-desc {
  font-size: 13px;
  color: #555;
}
</style>
